import axios from 'axios';
import TokenService from './tokenService';

export const BASE_API_URL = import.meta.env.VITE_API_URL;

if (!BASE_API_URL) {
  console.error('❌ VITE_API_URL is not set! API calls will fail.');
  console.error('💡 Make sure your .env.production file contains: VITE_API_URL=https://api.begig.io');
  console.error('💡 Vite only exposes variables prefixed with VITE_, not REACT_APP_');
}

const httpConfig = {
  baseURL: BASE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

const httpClient = axios.create(httpConfig);

// Add a request interceptor to update headers before each request
httpClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle successful responses
httpClient.interceptors.response.use(
  (response) => {
    // Check if response.data is defined
    return response.data !== undefined ? response.data : {};
  },
  (error) => {
    error.message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed! Something went wrong.';

    console.error('Error:', error);
    return Promise.reject(error);
  }
);

export default httpClient;
